import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { Enterprise, RegisterParams, User, UserParams } from './types';

export const UPDATE_USER = 'auth/UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'auth/UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'auth/UPDATE_USER_ERROR';

export const LOGIN_USER = 'auth/LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'auth/LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'auth/LOGIN_USER_ERROR';

export const GET_LOGGED_IN_USER = 'auth/GET_LOGGED_IN_USER';
export const GET_LOGGED_IN_USER_SUCCESS = 'auth/GET_LOGGED_IN_USER_SUCCESS';
export const GET_LOGGED_IN_USER_ERROR = 'auth/GET_LOGGED_IN_USER_ERROR';

export const LOGOUT_USER = 'auth/LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'auth/LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_ERROR = 'auth/LOGOUT_USER_ERROR';

export const GET_MY_ENTERPRISE = 'auth/GET_MY_ENTERPRISE';
export const GET_MY_ENTERPRISE_SUCCESS = 'auth/GET_MY_ENTERPRISE_SUCCESS';
export const GET_MY_ENTERPRISE_ERROR = 'auth/GET_MY_ENTERPRISE_ERROR';

export const REGISTER_USER = 'auth/REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'auth/REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'auth/REGISTER_USER_ERROR';

export const REGISTER_USER_AND_ENTERPRISE = 'auth/REGISTER_USER_AND_ENTERPRISE';
export const REGISTER_USER_AND_ENTERPRISE_SUCCESS =
  'auth/REGISTER_USER_AND_ENTERPRISE_SUCCESS';
export const REGISTER_USER_AND_ENTERPRISE_ERROR =
  'auth/REGISTER_USER_AND_ENTERPRISE_ERROR';

export const GET_LOGGED_IN_ENTERPRISE = 'auth/GET_LOGGED_IN_ENTERPRISE';
export const GET_LOGGED_IN_ENTERPRISE_SUCCESS =
  'auth/GET_LOGGED_IN_ENTERPRISE_SUCCESS';
export const GET_LOGGED_IN_ENTERPRISE_ERROR =
  'auth/GET_LOGGED_IN_ENTERPRISE_ERROR';

export const REGISTER_MEMBER = 'auth/REGISTER_MEMBER';
export const REGISTER_MEMBER_SUCCESS = 'auth/REGISTER_MEMBER_SUCCESS';
export const REGISTER_MEMBER_ERROR = 'auth/REGISTER_MEMBER_ERROR';

export const REGISTER_ADMIN = 'auth/REGISTER_ADMIN';
export const REGISTER_ADMIN_SUCCESS = 'auth/REGISTER_ADMIN_SUCCESS';
export const REGISTER_ADMIN_ERROR = 'auth/REGISTER_ADMIN_ERROR';

export const updateUserAsync = createAsyncAction(
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
)<UserParams, User, AxiosError>();

export const loginUserAsync = createAsyncAction(
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
)<any, User, AxiosError>();

export const getLoggedInUserAsync = createAsyncAction(
  GET_LOGGED_IN_USER,
  GET_LOGGED_IN_USER_SUCCESS,
  GET_LOGGED_IN_USER_ERROR,
)<any, User, AxiosError>();

export const logoutUserAsync = createAsyncAction(
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  LOGOUT_USER_ERROR,
)();

export const getMyEnterpriseAsync = createAsyncAction(
  GET_MY_ENTERPRISE,
  GET_MY_ENTERPRISE_SUCCESS,
  GET_MY_ENTERPRISE_ERROR,
)<string, Enterprise, AxiosError>();

export const registerUserAsync = createAsyncAction(
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_ERROR,
)<RegisterParams, User, AxiosError>();

export const registerUserAndEnterpriseAsync = createAsyncAction(
  REGISTER_USER_AND_ENTERPRISE,
  REGISTER_USER_AND_ENTERPRISE_SUCCESS,
  REGISTER_USER_AND_ENTERPRISE_ERROR,
)<RegisterParams, User, AxiosError>();

export const registerMemberAsync = createAsyncAction(
  REGISTER_MEMBER,
  REGISTER_MEMBER_SUCCESS,
  REGISTER_MEMBER_ERROR,
)<RegisterParams, User, AxiosError>();

export const registerAdminAsync = createAsyncAction(
  REGISTER_ADMIN,
  REGISTER_ADMIN_SUCCESS,
  REGISTER_ADMIN_ERROR,
)<RegisterParams, User, AxiosError>();
